import http from "@/http/http";
import { AxiosPromise } from "axios";

function fetchNotifications(chartGroupId: number, page?: number): AxiosPromise {
  const params = page ? { page } : {};
  return http.get(`/chart_groups/${chartGroupId}/patient_user_notifications`, {
    params,
  });
}

function markNotificationAsRead(
  chartGroupId: number,
  notificationId: number
): AxiosPromise {
  return http.put(
    `/chart_groups/${chartGroupId}/patient_user_notifications/${notificationId}`
  );
}

function fetchAdditionalNotifications(
  chartGroupId: number,
  page: number
): AxiosPromise {
  return fetchNotifications(chartGroupId, page);
}

export default {
  fetchNotifications,
  markNotificationAsRead,
  fetchAdditionalNotifications,
};
